/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_State_UpcomingInputs */



/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Tournaments_Lib_State_UpcomingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_state_upcoming = /** @type {((inputs?: Tournaments_Lib_State_UpcomingInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_State_UpcomingInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bevorstehend")
	if (locale === "fr") return /** @type {LocalizedString} */ ("À venir")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("即将开始")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("即將舉行")
	if (locale === "ko") return /** @type {LocalizedString} */ ("예정")
	return /** @type {LocalizedString} */ ("Upcoming")
});